import { LoaderConfig } from '@vueling-ng/vy-ds/src/lib/components/globals/loaders/loader';
import { SpinnerColorEnum } from '@vueling-ng/vy-ds/src/lib/components/globals/loaders/spinner';

export const LangMap: Record<string, string> = {
  en: 'en-GB',
  es: 'es-ES',
  fr: 'fr-FR',
  de: 'de-DE',
  it: 'it-IT',
  pt: 'pt-PT',
  nl: 'nl-NL',
  gl: 'gl-ES',
  ca: 'ca-ES',
  eu: 'eu-ES'
};

export const loaderPrimaryConfig: LoaderConfig = {
  accessibilityStatusText: '',
  isOpen: false,
  spinnerColor: SpinnerColorEnum.PRIMARY
};
